import "../theme/LoginView.scss";
import bgOne from "../assets/images/bg-one.jpg";
import { FormLogin } from "../components/FormLogin";

export default function LoginView() {
  return (
    <div
      className="login-page"
      style={{ "--login-background-image": `url(${bgOne})` }}
    >
      <main className="login-shell">
        <section className="login-intro" aria-labelledby="login-welcome-title">
          <div className="login-intro__orbit login-intro__orbit--one" aria-hidden="true" />
          <div className="login-intro__orbit login-intro__orbit--two" aria-hidden="true" />

          <div className="login-intro__content">
            <img
              src="/img/default-profile.jpg"
              alt="Técnica de Lectura"
              className="login-intro__logo"
            />
            <div className="login-intro__guide" aria-hidden="true" />
            <h1 id="login-welcome-title">Bienvenido</h1>
            <p>Ingresa tus datos para continuar con tu proceso de lectura.</p>
          </div>

          <span className="login-intro__version">V2.2.2</span>
        </section>

        <section className="login-form-panel" aria-labelledby="login-form-title">
          <div className="login-form-panel__content">
            <header className="login-form-panel__header">
              <span className="login-form-panel__eyebrow">Acceso a la plataforma</span>
              <h2 id="login-form-title">Iniciar sesión</h2>
              <p>
                Si tu acceso requiere validación previa, te avisaremos aquí mismo
                al intentar ingresar.
              </p>
            </header>
            <FormLogin />
          </div>
        </section>
      </main>
    </div>
  );
}
